import MarketingPage from './components/MarketingPage';

function App() {
  return (
    <MarketingPage />
  );
}

export default App;